export default __webpack_public_path__ + "resources/icons/d411-1bcd.png";